import React from "react";
import logo from "../assets/svg/logo.svg";
import styles from "../styles/header.module.scss";

export default () => (
  <span className={styles.logoLink}>
    <img className={styles.logo} src={logo} alt="" />
  </span>
);
